import React, { useState } from "react";

import { useApi } from "../../../../../api";
import I18nText from "../../../../../elements/I18nText";
import ConfirmationDialog from "../../../../../elements/ConfirmationDialog";
import { DeleteButton } from "../../../../../elements/Button";

const DeleteContainer = ({ deviceId, commentId, onCancel, onDeleted }) => {
  const api = useApi();
  const [isDeleting, setDeleting] = useState(false);

  const deleteComment = () => {
    setDeleting(true);

    api.delete(`/v2/devices/${deviceId}/comment/${commentId}`).then(() => {
      setDeleting(false);
      onDeleted();
    });
  };

  return (
    <ConfirmationDialog
      onCancel={onCancel}
      isSubmitting={isDeleting}
      ConfirmButton={
        <DeleteButton disabled={isDeleting} onClick={deleteComment} />
      }
    >
      <I18nText>devices.settings.metadata.comment.deleteConfirmation</I18nText>
    </ConfirmationDialog>
  );
};

export default DeleteContainer;
